import React from "react";

export default function PackageIcon({ className = "svg-308", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 20 20" fill="none" className={className} aria-hidden="true" {...props}>
      <rect width="20" height="20" rx="10" fill="#EFF6FF" />
      <path
        d="M7.95832 8.83332H12.0417M7.95832 6.79175H12.0417M11.1667 13.5002L7.95832 10.8752L8.83332 10.8751C11.426 10.8751 11.426 6.79175 8.83332 6.79175M15.8333 10.0001C15.8333 13.2217 13.2217 15.8334 9.99999 15.8334C6.77833 15.8334 4.16666 13.2217 4.16666 10.0001C4.16666 6.77842 6.77833 4.16675 9.99999 4.16675C13.2217 4.16675 15.8333 6.77842 15.8333 10.0001Z"
        stroke="#2563EB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
